import React from 'react'

const Denied = () => {

    return (
        <p>Sorry, you do not have access to Absolute Collateral</p>
    )
}

export default Denied